import React, { useEffect, useMemo, useState } from "react";
import { withStyles } from "@mui/styles";
import PropTypes from "prop-types";

import HomeStandard from "../HomeStandard";
import HomeGruppe from "../HomeGruppe";
import { useLocalStorage, useSessionStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import { useZulassung } from "../../context/zulassungs-context";
import { useAuth } from "../../context/auth-context";

const styles = (theme) => ({
  paper: {
    margin: theme.spacing(2),
  },
  form: {
    margin: theme.spacing(1),
    flex: 1,
  },
  avatar: {
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    backgroundColor: theme.palette.secondary.main,
  },
});

function Home(props) {
  const { classes, title, updateTitle } = props;

  const allowedPrograms = [
    "PMBZE0",
    "UMSTAT",
    "PMURA1",
    "PMURA3",
    "WEBPDB",
    "ADRWEB",
    "PZKOA0",
    "INOBRW",
    "PZKDR0",
    "PMAST0",
    "CWARCH",
    "LTERW2",
    "LWEB01",
    "DMSBAP",
    "PMABWU",
    "SENDAU",
    "GESEND",
    "WEBAGU",
    "LWEB02",
    "ZANLIM",
    "ZANLIA",
    `IV0022`,
    "SPLANT",
    "FORANT",
    `PMVER0`,
    "PPROJN",
    "PPROJ2",
    "PPROJ3",
    "WEBAD2",
    "PMURB3",
    "SNDAUM",
    "FORGEN",
    "FORAUS",
    "WEBWGD",
    "PMAST1",
    "WEBDMS",
    "LA1MAP-INIT_AN",
    "LPB1AP",
    "PMABW2",
    "PMABW3",
    "WEBAD3",
    "WEBZFP-MODUL",
    "WEBZF2",
    "LA1MAP",
    "ZANLII",
    "WEBPDS",
    "FWEBEG",
    "FORMUL",
    "FORMAD",
    "WEBAGG",
    `HRFIRE`,
    `HRTURN`,
    `HRAUFG`,
    `HRLORT`,
    "TUERAP",
    "AWARCH",
    "FORMAM",
    "PCRSHO",
    "PERSMA",
    "PERSMM",
    "HVATAN",
    "KMPAPI",
  ]; // 'WEBABR', 'LKFZVW',

  const [accessToken] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const { zulassung, updatePrograms, updateMandant } = useZulassung();
  const { user } = useAuth();

  const programs = useMemo(() => zulassung.programs, [zulassung]);

  useEffect(() => {
    remove_filter();
  }, []);

  const remove_filter = () => {
    localStorage.removeItem("PMABWU_FILTER");
    localStorage.removeItem("ZANLIM_FILTER");
    localStorage.removeItem("WEBPDB_FILTER");
    localStorage.removeItem("PZKOA0_FILTER");
    localStorage.removeItem("WEBAGU_FILTER");
    localStorage.removeItem("WEBAGU_FILTER_OFFENE");
    localStorage.removeItem("WEBAGU_ANSICHT");
    localStorage.removeItem("HAUFST_FILTER");
    localStorage.removeItem("form_showLohnarten");
    localStorage.removeItem("HRAUFG_ANSICHT");
    localStorage.removeItem("AbsenceArchFilter");
    localStorage.removeItem("AbsenceArchData");
    localStorage.removeItem("scrollPositionAbsenceArch");
    localStorage.removeItem("scrollPositionAbsenceConfirm");
    localStorage.removeItem("KabelSucheFilter");
    localStorage.removeItem("DeviceSucheFilter");
  };

  return (
    <>
      <HomeGruppe
        accessToken={accessToken}
        classes={classes}
        programs={programs}
        updatePrograms={updatePrograms}
        title={title}
        updateTitle={updateTitle}
        allowedPrograms={allowedPrograms}
        updateClient={updateMandant}
      />
    </>
  );
}

Home.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Home);
